<template>
  <div class="hello">    
	<picture-input 
		ref="pictureInput" 
		@change="change"
		@loaded="loaded"
		@resized="resized"
		width="720" 
		height="720" 
		margin="16" 
		accept="image/jpeg,image/png" 
		size="10" 
		:crop="false"
		:custom-strings="{
							upload: '<h1>Bummer!</h1>',
							drag: 'Drag an image 😺'
						}"
		:hide-change-button="true">
	</picture-input>
	<div id="payment" v-if="dropped"> 
		<stripe-elements
		ref="elementsRef"
		:pk="publishableKey"
		:amount="amount"
		@token="tokenCreated"
		@loading="loading = $event"
		>
		</stripe-elements>
		<button @click="submit">Shut up and take my  ${{amount / 100}}</button>
	</div>
  </div>
</template>


<script>
import PictureInput from 'vue-picture-input'
import { StripeElements } from 'vue-stripe-checkout';

var hull = require("hull.js")
var bleed_canvas;
var cutBleed = 50;

export default {
  name: 'app',
  data: () => ({
    loading: false,
    publishableKey: "pk_test_k8h2PYj9Vlc2pkIQ8tHwt22I00uyDQEhHC",
    token: null,
    charge: null,
	amount: 599,
	dropped: false
  }),
  components: {
    PictureInput,
	StripeElements
  },
  methods: {
    change() {
			console.log('New picture selected!');
			if (this.$refs.pictureInput.image) {
				console.log('Picture loaded.')
			} else {
				console.log('FileReader API not supported: use the <form>, Luke!')
			}
		},
	loaded() {
		if(bleed_canvas === undefined){
			bleed_canvas = document.createElement("canvas");
			bleed_canvas.className = "bleed";
			bleed_canvas.width = 720;
			bleed_canvas.height = 720;
			bleed_canvas.style.cssText = "position: absolute; left: 0; top: 0; ";
			this.$refs.pictureInput.$refs.previewCanvas.parentElement.appendChild(bleed_canvas);
		} else {
			bleed_canvas.getContext('2d').clearRect(0, 0, bleed_canvas.width, bleed_canvas.height);
		}
		
		stickerize(this.$refs.pictureInput.$refs.previewCanvas, bleed_canvas);
		console.log('New picture stickerized.');
		this.dropped = true;
	},
	resized() {
		this.loaded();
		console.log('resizeeeeeeeeeeeeed');
	},
	submit () {
      this.$refs.elementsRef.submit();
    },
    tokenCreated (token) {
      this.token = token;
      // for additional charge objects go to https://stripe.com/docs/api/charges/object
      this.charge = {
        source: token.card,
        amount: this.amount,
        description: this.description
      }
      this.sendTokenToServer(this.charge);
    },
    sendTokenToServer (charge) {
      alert("Ordered");
      console.log(charge);
    }
  }
}

function background(pixels, index){
	var r = pixels[index],
		g = pixels[index + 1],
		b = pixels[index + 2],
		a = pixels[index + 3];
	
	return ((r >= 245 && g >= 245 && b >= 245) | (a <= 10));	
}

function stickerize(canvas, bleed_canvas){
	var w = canvas.width, h = canvas.height;
	
	var ctxt = canvas.getContext("2d");
	var img_data = ctxt.getImageData(0, 0, w, h);
	var pixels = img_data.data;

	var points = [];
  var previous, i, transparent, concave_hull;

	var x, y;
  
  // make transparent
  for (x = 0; x < w; x++) {
		for (y = 0; y < h; y++) {
			i = w * 4 * y + x * 4;
			if(background(pixels, i)){
        pixels[i + 3] = 0; // make transparent
      }
    }
	}

  // horizontal scanning
	for (y = 0; y < h; y++) {
		previous = 1;
		for (x = 0; x < w; x++) {
			i = w * 4 * y + x * 4;
			transparent = (pixels[i + 3] == 0);
			if (transparent != previous) {
				points.push([x, y]); // normal edge pixel
			}
			previous = transparent;
		}
	}

	// vertical scanning
	for (x = 0; x < w; x++) {
		previous = 1;
		for (y = 0; y < h; y++) {
			i = w * 4 * y + x * 4;
			transparent = (pixels[i + 3] == 0);
			if (transparent != previous) {
				points.push([x, y]); // normal edge pixel
			}
			previous = transparent;
		}
	}

	concave_hull = hull(points, 10); // returns points of the hull (in clockwise order)
	
	ctxt.putImageData(img_data, 0, 0);
	drawCutContour(concave_hull, bleed_canvas, cutBleed);
}

function drawCutContour(concave_hull, canvas, bleed) {
	var g = canvas.getContext('2d');

	g.beginPath();
    g.moveTo(concave_hull[0][0], concave_hull[0][1]);
    concave_hull.forEach(function(p) {
        g.lineTo(p[0], p[1]);
    });
    g.lineTo(concave_hull[0][0], concave_hull[0][1]);
    g.closePath();
	
	g.lineCap = "round";
	g.lineJoin = "round";
	g.lineWidth = bleed;
	g.strokeStyle = "#fff";
	g.stroke();

	g.fillStyle = "#fff";
	g.fill();
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.preview-container {
  position: relative;
}

#payment {
	width: 420px;
	margin: 0 auto;
	text-align:center;
}

#payment button {
  border-radius: 100rem;
  padding: 1rem;
  margin:14px;
  font-size: 1rem;
  padding: .5rem 3rem;
  color: $color-black;
  box-shadow: 0 0 6px 0 rgba(157, 96, 212, 0.5);
  border: solid 3px transparent;
  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(101deg, #78e4ff, #ff48fa);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

#payment button:hover {
  box-shadow: none;
  color: white;
}


#payment #payment-form button{
	display: none;
}
</style>
